import { axios } from '~/clients';
import { GET_DEVICE_DETECTION } from '~/constants/endpoints';

const fetchDeviceDetection = (userAgent: string, controller: AbortController) =>
  axios.get(GET_DEVICE_DETECTION, {
    headers: {
      'user-agent': userAgent
    },
    signal: controller.signal
  });

export default fetchDeviceDetection;
